module.exports = __webpack_public_path__ + "img/whyOrange.68ad1f22.jpg";